import React, { useEffect, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';

import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

import {
    CreateUserPreferences,
    GetUserPreferencesByUserId,
    UpdateUserPreferences,
} from '../reduxToolkit/UserPreferences/UserPreferencesApi';
import { useDispatch, useSelector } from 'react-redux';
import { BACK_TO_UI_LANG, UI_TO_BACK_LANG } from '../pages/Home/Model/HomeModel';
import { errorMsg, syncI18nLanguageFromBackend } from '../Apis/functions';
import { englishFlag, franceFlag, Language, spanishFlag } from './buttons/IconButtons';

const languages = [
    { id: 1, name: 'spanish', code: 'sp', flag: spanishFlag },
    { id: 2, name: 'english', code: 'en', flag: englishFlag },
    { id: 3, name: 'french', code: 'fr', flag: franceFlag },
];

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => {
    const { t } = useTranslation();

    return (
        <div
            ref={ref}
            onClick={(e) => onClick(e)}
            className={'d-flex justify-content-between align-items-center w-195px'}
        >
            {children}
            <p className='fs-14px font-color-general-950 ibl-font-w-400 ml-0 pl-1'>{t('language')}</p>
            <Language className={'w-44px h-24px p-1'} />
        </div>
    );
});

const LanguageSelector = ({ isMenuOpen, menutop }) => {
    const userData = useSelector((state) => state?.authenticatioauthennSlice?.user.data);
    const userLanguage = useSelector((state) => state?.UserPreferencesSlice?.getUserPreferencesByUserId);

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [currentLanguage, setCurrentLanguage] = useState({});
    const [open, setOpen] = useState(false);
    const languageDropDirection = menutop ? 'start' : 'end';

    useEffect(() => {
        const uiLang = syncI18nLanguageFromBackend(userLanguage?.language);
        setCurrentLanguage(languages.find((l) => l.code === uiLang));
    }, [userLanguage?.language]);

    // UI effects
    useEffect(() => {
        const currentLanguageCode = i18next.language || BACK_TO_UI_LANG.EN;

        document.body.dir = currentLanguage?.dir || 'ltr';
        document.body.style.textAlign = currentLanguageCode === 'ar' ? 'right' : 'left';
        document.title = t('app_title');

        window.postMessage(
            {
                type: 'languageChange',
                newValue: currentLanguageCode,
            },
            '*',
        );
    }, [currentLanguage, t]);

    const handleSelect = (code) => {
        if (i18next.language !== code) {
            i18next.changeLanguage(code);
        }

        setCurrentLanguage(languages.find((l) => l.code === code));

        const isCreate = userLanguage?.id == null;

        const params = isCreate
            ? {
                userId: userData.id,
                language: UI_TO_BACK_LANG[code] ?? UI_TO_BACK_LANG.en,
            }
            : {
                id: userLanguage.id,
                userId: userData.id,
                language: UI_TO_BACK_LANG[code] ?? UI_TO_BACK_LANG.en,
            };

        dispatch((isCreate ? CreateUserPreferences : UpdateUserPreferences)(params)).then(({payload:{data:{data,success,code}}})=>{
            if(success){
                if(userData?.id){
                    dispatch(GetUserPreferencesByUserId(userData.id))
                }
            }
            else errorMsg(code)
        });
        setOpen(false);
    };

    const currentLanguageCode = i18next.language || BACK_TO_UI_LANG.EN;

    return (
        <div className='languageSelector'>
            <Dropdown drop={languageDropDirection} show={open} onToggle={() => setOpen(!open)}>
                <Dropdown.Toggle as={CustomToggle} />
                <Dropdown.Menu
                    className={
                        (menutop === false &&
                            (currentLanguageCode === 'ar'
                                ? isMenuOpen
                                    ? 'leftArbicL'
                                    : 'leftArbicLClose'
                                : isMenuOpen
                                  ? 'notleftL'
                                  : 'notleftLClose')) ||
                        (menutop === true && (currentLanguageCode === 'ar' ? 'leftArbicLM' : 'notleftLM'))
                    }
                    size='sm'
                    title='Change Languages'
                >
                    {languages?.map((value) => {
                        const FlagIcon = value.flag;
                        return (
                            <div
                                className={`dropdownDivMenu pl-10px pr-10px ${currentLanguage?.code === value.code ? 'activeDrop' : ''}`}
                                key={value.id}
                                onClick={() => handleSelect(value.code)}
                            >
                                <div className='d-flex align-items-center justify-content-between w-100'>
                                    <span className='fs-14px font-color-general-950 ibl-font-w-400'>
                                        {t(value.name)}
                                    </span>
                                    <FlagIcon className='mx-2 w-6 h-6' />
                                </div>
                            </div>
                        );
                    })}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default LanguageSelector;
